require('./src/components/layout.css')